import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import TopBar from './components/TopBar';
import Header from './components/Header';
import Footer from './components/Footer';
import { Toaster } from './components/ui/toaster';

import Home from './pages/Home';
import About from './pages/About';
import IsoStandard from './pages/IsoStandard';
import Services from './pages/Services';
import Projects from './pages/Projects';
import Contact from './pages/Contact';
import News from './pages/News';
import ScrollToTop from './components/ScrollToTop';


// ⭐ Import BatteriesSection directly
import Batteries from './pages/Batteries';



function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <TopBar />
        <Header />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/company" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/news" element={<News />} />
          <Route path="/features" element={<Services />} />
          <Route path="/isostandard" element={<IsoStandard/>} />
          

          {/* ⭐ Use BatteriesSection directly */}
          <Route path="/products/batteries" element={<Batteries />} />
       
        </Routes>

        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
